import Navbar from '@/components/feature/Navbar';
import DandelionHero from './components/DandelionHero';

export default function Home() {
  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <DandelionHero />
    </div>
  );
}